import React from 'react';
import { Link } from 'react-router-dom';

export interface LinkCellProps {
  /** The text to display */
  children: React.ReactNode;
  /** The route to navigate to */
  to: string;
  /** Additional CSS classes */
  className?: string;
  /** Whether the link is disabled */
  disabled?: boolean;
  /**
   * Click handler forwarded to the underlying link. Used to stop propagation
   * when the cell sits inside a clickable table row so the link navigation is
   * not overwritten by the row's own navigation.
   */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  /** Open in a new browser tab, keeping the current view in place. */
  newWindow?: boolean;
}

export const LinkCell: React.FC<LinkCellProps> = ({
  children,
  to,
  className = '',
  disabled = false,
  onClick,
  newWindow = false,
}) => {
  if (disabled) {
    return <span className={`text-default-500 ${className}`}>{children}</span>;
  }

  return (
    <Link
      to={to}
      onClick={onClick}
      target={newWindow ? '_blank' : undefined}
      rel={newWindow ? 'noopener noreferrer' : undefined}
      className={`text-primary hover:text-primary-600 hover:underline transition-colors duration-200 ${className}`}
    >
      {children}
    </Link>
  );
};
